export const initialViventiumSettingsData = {
  regular: null as any,
  overtime: null as any,
  double_overtime: null as any,
  mileage: null as any,
};
